import type { GroupId } from '@vlabs/api/artemy/model';
import { useParams } from 'react-router-dom';

export function useGroupIdFromLocation(): GroupId {
  const { groupId } = useParams<{ groupId: GroupId }>();

  return groupId;
}
